<template>
  <v-container pa-0>
    <v-row class="ml-3 mt-n9">
      <div class='headline' v-if="!isOperator">Мои заявки</div>
      <div class='headline' v-else>{{ ticketTypes[typeId].name.replace('Заявка', 'Заявки') }}</div>
    </v-row>
    <v-card class="mt-9 pa-5">
      <v-row>
        <v-col sm=6 md=2 cols=12>
          <v-menu :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="100px" v-model="isStartOpened">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="startDateFormatted" @blur="startDate = parseDate(startDateFormatted)" color="secondary" label="С..." prepend-inner-icon="event" class="data-input" readonly dense v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="startDate" color="secondary" locale="ru-ru" :max="endDate" @click:date="isStartOpened=false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col sm=6 md=2 cols=12>
          <v-menu :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="100px" v-model="isEndOpened">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="endDateFormatted" @blur="endDate = parseDate(endDateFormatted)" color="secondary" label="По..." prepend-inner-icon="event" class="data-input" readonly dense v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="endDate" color="secondary" locale="ru-ru" :min="startDate" :max="today" @click:date="isEndOpened=false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col sm=6 md=2 cols=12>
          <v-select label="Статус заявки" :items="statuses" v-model="ticketStatus" dense class="filter-input mr-3"></v-select>
        </v-col>
        <v-col sm=6 md=2 cols=12>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-select label="Срок исполнения заявки" v-if="isOperator" :items="[{value: 0, text: 'Все'}, {value: 1, text: 'Скоро истекает'}, {value: 2, text: 'Истёк'}]" v-model="ticketStatusExpire" dense class="filter-input"></v-select>
              </div>
              <!-- <v-chip small>?</v-chip>-->
            </template>
            <span>Срок статуса считается истёкшим по истечении 30-ти дней со дня изменения статуса заявки или с момента превышения назначенного срока.<br>Скоро истекает - осталось 5 дней до истечения срока.</span>
          </v-tooltip>
        </v-col>
        <v-spacer d-sm-none d-md-flex></v-spacer>
        <v-col sm=12 md=2 cols=12>
          <v-text-field label="Поиск" v-model="search" dense style="float: right" class="filter-input">
          </v-text-field>
        </v-col>
      </v-row>
      <v-row class="mt-n5" align="start">
      </v-row>
      <v-row class="mb-2 mt-4">
        <v-col>
          <v-btn color="primary" small dark @click.prevent="$router.push({path: '/tickets/new_question'})" v-if="typeId == 5">
            Добавить обращение
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table v-if="!isOperator" :headers="user_headers" :items="filteredItems" :items-per-page="10" class="elevation-0" :loading="searchDialog" :custom-sort="customSort" @click:row="openTicket"></v-data-table>
      <v-data-table v-else :headers="operator_headers" :items="filteredItems" :items-per-page="10" class="elevation-0" :loading="searchDialog" :custom-sort="customSort" @click:row="openTicket"><template v-slot:item="item">
          <tr @click="openTicket(item.item)" :class="{ 'expired-ticket': isExpired(item.item), 'close-ticket': isClose(item.item) }">
            <td>{{ item.item.date }}</td>
            <td>{{ item.item.type }}
              <v-chip class="ma-2" color="blue" small tag v-if="item.item.is_offline" text-color="white">
                Оффлайн
              </v-chip>
            </td>
            <td>{{ item.item.code }}</td>
            <td>{{ item.item.status }}</td>
            <td>{{ item.item.operator }}</td>
            <td>{{ item.item.status_date }}</td>
            <td v-if="typeId == 5">{{ item.item.expiration_time }}</td>
            <td v-if="isSuperuser">
              <v-icon small @click.stop.prevent="deleteItem(item)">
                mdi-delete
              </v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small @click.stop.prevent="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template></v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { convertDate, parseDate, getTodayDate } from '@/utils'

const completionStatuses = [6, 7] //id статусов, которые означают завершённость заявки

export default {
  name: 'TicketList',

  props: {
    isOperator: {
      default: false
    },
    typeId: {
      default: null
    }
  },

  data: () => ({
    user_headers: [
      { text: 'Дата', value: 'date' },
      { text: 'Тип', value: 'type' },
      { text: 'Номер', value: 'code' },
      { text: 'Статус', value: 'status' }
    ],
    tickets: [],
    statuses: [{ text: 'Все', value: -1 }],
    complStatNames: [],
    ticketStatus: -1,
    searchDialog: false,
    ticketStatusExpire: 0,
    isEndOpened: false,
    isStartOpened: false,
    startDate: new Date('2020-01-01').toISOString().substr(0, 10),
    endDate: getTodayDate(),
    startDateFormatted: convertDate(new Date('2020-01-01').toISOString().substr(0, 10)),
    endDateFormatted: convertDate(new Date().toISOString().substr(0, 10)),
    search: ''
  }),

  watch: {
    startDate(val) {
      this.startDateFormatted = convertDate(this.startDate)
    },
    endDate(val) {
      this.endDateFormatted = convertDate(this.endDate)
    }
  },

  computed: {
    ...mapGetters({
      userLogin: 'user/userLogin',
      ticketTypes: 'common/ticketTypes',
      userRoles: 'user/userRoles'
    }),
    today: () => { return getTodayDate() },
    isSuperuser: function() { return this.userRoles.includes('superuser') },
    operator_headers: function() {
      if (this.typeId == 5) {
        if (this.userRoles.includes('superuser')) {
          return [
            { text: 'Дата', value: 'date' },
            { text: 'Тип', value: 'type' },
            { text: 'Номер', value: 'code' },
            { text: 'Статус', value: 'status' },
            { text: 'Назначена на', value: 'operator' },
            { text: 'Дата изменения статуса', value: 'status_date' },
            { text: 'Срок исполнения заявки', value: 'expiration_time' },
            { text: '', value: 'actions', sortable: false }
          ]
        } else {
          return [
            { text: 'Дата', value: 'date' },
            { text: 'Тип', value: 'type' },
            { text: 'Номер', value: 'code' },
            { text: 'Статус', value: 'status' },
            { text: 'Назначена на', value: 'operator' },
            { text: 'Дата изменения статуса', value: 'status_date' },
            { text: 'Срок исполнения заявки', value: 'expiration_time' },
          ]
        }
      } else {
        if (this.userRoles.includes('superuser')) {
          return [
            { text: 'Дата', value: 'date' },
            { text: 'Тип', value: 'type' },
            { text: 'Номер', value: 'code' },
            { text: 'Статус', value: 'status' },
            { text: 'Назначена на', value: 'operator' },
            { text: 'Дата изменения статуса', value: 'status_date' },
            { text: '', value: 'actions', sortable: false }
          ]
        } else {
          return [
            { text: 'Дата', value: 'date' },
            { text: 'Тип', value: 'type' },
            { text: 'Номер', value: 'code' },
            { text: 'Статус', value: 'status' },
            { text: 'Назначена на', value: 'operator' },
            { text: 'Дата изменения статуса', value: 'status_date' }
          ]
        }
      }
    },
    filteredItems: function() {
      let searchQuery = this.search.toLowerCase()
      let status = ''
      for (let s in this.statuses) {
        if (this.statuses[s].value == this.ticketStatus) status = this.statuses[s].text
      }
      let self = this
      let statusItems = this.tickets.filter((item) => {
        return (self.ticketStatus == -1) || (item.status === status)
      })
      statusItems = this.filterItems(statusItems, searchQuery)
      statusItems = statusItems.filter((item) => {
        return this.isDateInRange(item.date)
      })
      if (this.ticketStatusExpire == 1) {
        return statusItems.filter((item) => {
          return self.isClose(item)
        })
      }
      if (this.ticketStatusExpire == 2) {
        return statusItems.filter((item) => {
          return self.isExpired(item)
        })
      }
      return statusItems
    }
  },

  created: function() {
    this.getStatuses()
    if (this.isOperator) this.getOperatorTickets()
    else this.getUserTickets()
  },

  methods: {
    filterItems: function(items, search) {
      return items.filter((item) => {
        for (let prop in item) {
          if (Array.isArray(item[prop])) {
            for (let ind in item[prop]) {
              if (item[prop][ind].toLowerCase().indexOf(search) != -1) return true
            }
          } else {
            if (item[prop]) {
              if (item[prop].toString().toLowerCase().indexOf(search) != -1) return true
            }
          }
        }
        return false
      })
    },
    parseDate: parseDate,
    deleteItem: async function(item) {
      if (confirm('Удалить заявку?')) {
        try {
          await this.$api.Account.delTicket(item.item.id)
          this.tickets = this.tickets.filter(obj => obj.id != item.item.id)
        } catch (e) {
          const err = e
          let error = 'Не удалось удалить заявку'
          await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
          console.error(e)
        }
      }
    },
    isExpired: function(item) {
      if (this.complStatNames.includes(item.status)) return false
      let statusDate = new Date(parseDate(item.status_date))
      let today = new Date()
      if (item.expiration_time != null) {
        if (today > new Date(parseDate(item.expiration_time))) return true
      }
      return Math.floor(((today - statusDate) / (60 * 60 * 24 * 1000))) > 30
    },
    isClose: function(item) {
      if (this.complStatNames.includes(item.status)) return false
      let statusDate = new Date(parseDate(item.status_date))
      let today = new Date()
      if (item.expiration_time != null) {
        let expirationDay = new Date(parseDate(item.expiration_time))
        let expiresIn = Math.floor(((expirationDay - today) / (60 * 60 * 24 * 1000)))
        if (expiresIn < 0) return false
        if (expiresIn < 5) return true
      }
      let days = Math.floor(((today - statusDate) / (60 * 60 * 24 * 1000)))
      return (days > 25 && days <= 30)
    },
    getStatuses: async function() {
      this.searchDialog = true
      try {
        const resp = await this.$api.Account.getTicketStatuses()
        //Получение названий статусов, которые говорят о завершённости заявки
        for (let item in resp.data) {
          if (completionStatuses.includes(resp.data[item]['value'])) this.complStatNames.push(resp.data[item]['text'])
        }
        //У заявки типа "Обращение по поводу коррупционного правонарушения" выводить только 3 статуса (Ожидание, принята, рассмотрена)
        for (let item in resp.data) {
          if (this.typeId != 6 || [1, 3, 7].includes(resp.data[item]['value'])) this.statuses.push(resp.data[item])
        }
        this.searchDialog = false
      } catch (e) {
        const err = e
        this.searchDialog = false
        let error = 'Не удалось загрузить статусы заявки'
        await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
        console.error(e)
      }
    },
    getUserTickets: async function() {
      //$router.push({ path: 'tickets/my_tickets/${}'})
      this.searchDialog = true
      try {
        const resp = await this.$api.Account.getUserTickets(this.userLogin)
        this.tickets = resp.data
        this.searchDialog = false
      } catch (e) {
        const err = e
        this.searchDialog = false
        if (e.response.status == 401) {
          await this.$store.dispatch('user/authLogOut')
          location.href = location.href
        }
        let error = 'Не удалось получить информацию о пользователе. Попробуйте повторить запрос позднее'
        await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
        console.error(e)
      }
    },
    getOperatorTickets: async function() {
      //$router.push({ path: 'tickets/my_tickets/${}'})
      this.searchDialog = true
      try {
        const resp = await this.$api.Account.getOperatorTickets(this.typeId)
        //if (this.userRoles.includes('user_self')) this.tickets = resp.data.filter(ticket => ticket.operator == this.userLogin)
        this.tickets = resp.data
        this.searchDialog = false
      } catch (e) {
        const err = e
        this.searchDialog = false
        if (e.response.status == 401) {
          await this.$store.dispatch('user/authLogOut')
          location.href = location.href
        }
        let error = 'Не удалось получить информацию о пользователе. Попробуйте повторить запрос позднее'
        await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
        console.error(e)
      }
    },
    //Функция проверяет, попадает ли дата в период startDate - endDate
    isDateInRange: function(itemDate) {
      let iDate = new Date(parseDate(itemDate))
      return iDate >= new Date(this.startDate) && iDate <= new Date(this.endDate)
    },
    sortFunc: function(a, b) {
      let aDate = new Date(parseDate(a.date))
      let bDate = new Date(parseDate(b.date))
      if (aDate < bDate) {
        return 1
      }
      if (aDate > bDate) {
        return -1
      }
      let aCode = parseInt(a.code)
      let bCode = parseInt(b.code)
      if (aCode > bCode) {
        return -1
      }
      if (aCode < bCode) {
        return 1
      }
      return 0
    },
    customSort: function(items, index, isDescending) {
      let self = this
      items.sort(function(a, b) {
        if (!isDescending[0]) {
          return self.sortFunc(a, b)
        } else {
          return self.sortFunc(b, a)
        }
      })
      return items
    },
    openTicket: function(item) {
      if (!this.isOperator) this.$router.push({ path: `/tickets/my_tickets/${item.id}` })
      else this.$router.push({ path: `/tickets/tickets_by_type/${this.typeId}/${item.id}` })
    }
  }
}
</script>
<style scoped>
.expired-ticket td {
  background-color: #FFEBEE;
}

.close-ticket td {
  background-color: #FFFDE7;
}

.filter-input {
  /*width: 250px;*/
  min-width: 100px;
  max-width: 100%;
  display: inline-block;
}

.data-input {
  min-width: 100px;
  max-width: 230px;
}

@media screen and (-ms-high-contrast: active),
(-ms-high-contrast: none) {
  .v-data-footer__select {
    display: none;
    /*margin-right: 160px!important;*/
  }

  .v-data-footer__pagination {
    /*display: none;*/
  }
}
</style>